import { dayCarePriceTable, FALLBACK_RCD_PER_SOL, type GameVersion, type RomPatch } from "@redchain/contracts";
import { applyRomPatch, ROM_PATCH_VERSION } from "@redchain/gen1-data";

const LAST_PATCH_KEY = "redchain.romPatch";

/**
 * §3.5: the ROM this session runs. The verifier replays with the same patch from the session row.
 * An offline session (no server patch) uses the last server patch seen on this device, so the game
 * always runs the patched rules.
 */
export function sessionRom(rom: Uint8Array, game: GameVersion, patch: RomPatch | null): Uint8Array {
  if (patch) {
    if (patch.version !== ROM_PATCH_VERSION) throw new Error("This page is out of date. Please reload.");
    localStorage.setItem(LAST_PATCH_KEY, patch.rcdPerSol);
  }
  const rcdPerSol = (patch ?? lastRomPatch()).rcdPerSol;
  return applyRomPatch(rom, dayCarePriceTable(BigInt(rcdPerSol)), game);
}

/** The last server patch seen on this device: what an offline session runs and reports when it is adopted. */
export function lastRomPatch(): RomPatch {
  return { version: ROM_PATCH_VERSION, rcdPerSol: localStorage.getItem(LAST_PATCH_KEY) ?? FALLBACK_RCD_PER_SOL.toString() };
}
